import { defaultHttpClient } from '../../httpClient';
import type { AffiliateGoodsResponse } from './types';

export const getAffiliateGoods = (goodsSno: number) => {
  return defaultHttpClient
    .request<AffiliateGoodsResponse>({
      method: 'GET',
      url: `/api/v2/affiliate/goods/${goodsSno}/`,
    })
    .then(result => result.data);
};
